export default "__VITE_ASSET__92f8da46__"